module.exports = __webpack_public_path__ + "img/1507489194.bc26cbe0.jpg";